import { Tween } from '../../pure/Timeline'

export default
{
    data()
    {
        return {
            rounds: []
        }
    },

    watch:
    {
        '$store.currentSlideID': 'updateRounds'
    },

    created()
    {
        this.currentSelected = -1
        this.rounds = this.$store.routes
            .filter(route => route.meta && route.meta.isSlide)
            .map((route, id) =>
            {
                const name = 'round' + id
                return {
                    id,
                    name,
                    path: route.path,
                    title: route.meta.title,
                    visible: true,
                    el: null,
                    circleEl: null,
                    pos: 1.5,
                    selected: false,
                    unicorn: route.name === 'contact'
                }
            })
    },

    mounted()
    {
        this.rounds.forEach(round =>
        {
            round.el = this.$refs.rounds[round.id]
            round.circleEl = round.el.querySelector('.js-circle')
        })

        this.updateRounds(this.$store.currentSlideID)
    },

    destroyed()
    {
        this.rounds = []
    },

    methods:
    {
        updateRounds(currentSlideID)
        {
            const rng = (min, max) => Math.random() * (max - min) + min
            const duration = 2000

            for (let round of this.rounds)
            {
                const to = (round.id - currentSlideID) / rng(4, 5) + 0.33
                const selected = round.id === currentSlideID

                // Position
                new Tween({
                    from: round.pos,
                    to,
                    duration,
                    easing: [
                        rng(0.5, 0.75), 0,
                        rng(0.25, 0.5), 1
                    ]
                })
                    .onChange(pos =>
                    {
                        round.pos = pos
                        this.updatePosition(round, pos)
                    })

                if (selected)
                {
                    round.selected = true

                    // Scale
                    new Tween({
                        from: 0,
                        to: 1,
                        duration: duration / 2,
                        delay: duration / 2
                    })
                        .onChange(scale =>
                        {
                            this.updateScale(round, scale, round.pos, round.unicorn ? 50 : 20)
                        })
                }
                else if (round.selected)
                {
                    round.selected = false

                    // Scale
                    new Tween({
                        from: 1,
                        to: 0,
                        duration: duration / 2
                    })
                        .onChange(scale =>
                        {
                            this.updateScale(round, scale, round.pos, round.unicorn ? 50 : 20)
                        })
                }
            }
        },

        updateScale(round, scale, pos, circleRadius = 20)
        {
            const ROUND_RADIUS = 0 // 4

            if (round.visible)
            {
                const getGap = scale => (scale * (circleRadius - ROUND_RADIUS) + ROUND_RADIUS)

                round.circleEl.style.transform = 'scaleX(' + scale + ') scaleY(' + scale + ')'

                this.$refs.lineTop.style.transform = 'translateY(' + (pos * 100).toFixed(1) + 'vh) ' + 'translateY(' + -getGap(scale).toFixed(1) + 'px) '
                this.$refs.lineBottom.style.transform = 'translateY(' + (pos * 100).toFixed(1) + 'vh)' + 'translateY(' + getGap(scale).toFixed(1) + 'px) '
            }
        },

        updatePosition(round, pos)
        {
            const visible = pos > -0.1 && pos < 1.1

            if (visible)
            {
                if (!round.visible)
                {
                    round.visible = visible
                    round.el.style.display = ''
                }

                round.el.style.transform = 'translateY(' + (pos * 100).toFixed(1) + 'vh)'
            }
            else
            {
                if (round.visible)
                {
                    round.visible = visible
                    round.el.style.display = 'none'
                }
            }
        }
    }
}
